import {useState, useEffect, MouseEventHandler, CSSProperties} from 'react';
import './ButtonGroup.css';

interface iProps {
  buttons: string[];
  onChange: MouseEventHandler<HTMLButtonElement>;
  groupLabel?: string;
  value: string;
  buttonHeight?: string;
  disabled?: boolean;
}

export default function ButtonGroup(props: iProps) {
  const [clickedButtonId, setClickedButtonId] = useState(-1);

  useEffect(() => {
    if(props.value) {
      const index = props.buttons.indexOf(props.value);
      setClickedButtonId(index);  
    }
  }, [props.value, props.buttons]);

  let buttonHeight: CSSProperties = {};
  if (props.buttonHeight) {
    buttonHeight = {height: props.buttonHeight}
  }
  return (
    <>
      <fieldset>
        {props.groupLabel && <legend>{props.groupLabel}</legend>}
        <div className={`button-group ${props?.disabled ? 'disabled' : ''}`} style={buttonHeight}>
          {props.buttons.map((label, index) => (
            <button
              key={index}
              name={label}
              onClick={(event) => props.onChange(event)}
              disabled={props?.disabled}
              className={index === clickedButtonId ? "button-group-button bg-yellow" : "button-group-button"}
            >
              {label}
            </button>
          ))}
        </div>
      </fieldset>
    </>
  )
}
